/* cache-bust: 2026-04-18-review-popup-v2 */
/* social-proof-popup.js  KAIDO non-customer reviews social-proof drawer.
 *
 * Gate: home/product pages only, not during cooldown, not for customers with active tokens,
 *       not for customers with a recent review (FR-15 currently hardwired false per pre-flight).
 * Trigger: whichever fires first of (scrollY >= max(800, 0.4 * scrollable)) or 15s.
 * Content: live stats from get_reviews?include_stats=1&page_size=1 (global stats).
 * CTA: smooth-scroll to .kaido-reviews-section with scroll-margin-top for sticky header.
 *      Fallback navigation to /pages/reviews when section not present.
 * Analytics: every state change emits to window.KAIDO.analytics.trackEvent wrapped in try/catch.
 * MutationObserver: self-destruct if the existing review-ticket drawer appears post-fire.
 * Accessibility: role=complementary, aria-labelledby on title, aria-live two-step insert,
 *                tabindex sync on collapsed tab, prefers-reduced-motion respected.
 */
(function () {
  var STORAGE_KEY = "kaido_social_proof_popup_state";
  /* v2 (2026-04-18): time + scroll triggers and auto-expand removed. The red
     square mounts on pageload (gated on logged-in customers via
     waitForReviewDrawerResolution) and only opens when the user clicks it. */
  /* v1.2: page_size=5 so we can pick a featured positive review to display alongside stats. */
  var STATS_ENDPOINT =
    "https://api.kaidomotors.com/functions/v1/get_reviews?include_stats=1&page_size=5";
  /* Cooldown removed: Kian wants the square to always reappear on every page load
     (unless customer has active review tokens, in which case existing drawer takes over). */

  var SVG_STAR_PATH =
    "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z";
  var SVG_ARROW_PATH = "M9 18l6-6-6-6";
  var SVG_CARET_DOWN_PATH = "M7 10l5 5 5-5z"; /* v1.6 toggle caret */

  /* State helpers kept for telemetry but NO cooldown enforcement  square is persistent. */
  function readState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return {};
      return JSON.parse(raw) || {};
    } catch (_) {
      return {};
    }
  }

  function writeState(patch) {
    try {
      var cur = readState();
      for (var k in patch) {
        if (Object.prototype.hasOwnProperty.call(patch, k)) cur[k] = patch[k];
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(cur));
    } catch (_) {}
  }

  function pageType() {
    if (window.KAIDO && typeof window.KAIDO.pageType === "string" && window.KAIDO.pageType) {
      return window.KAIDO.pageType;
    }
    var p = window.location.pathname || "";
    if (p === "/" || p === "") return "index";
    if (p.indexOf("/products/") === 0) return "product";
    return "other";
  }

  function getCustomerId() {
    try {
      var v = window.CURRENT_CUSTOMER_DATA && window.CURRENT_CUSTOMER_DATA.id;
      if (v === undefined || v === null || v === "") return null;
      return String(v);
    } catch (_) {
      return null;
    }
  }

  function track(eventType, payload) {
    try {
      if (window.KAIDO && window.KAIDO.analytics && window.KAIDO.analytics.trackEvent) {
        var md = { schema_version: 2 };
        if (payload) {
          for (var k in payload) {
            if (Object.prototype.hasOwnProperty.call(payload, k)) md[k] = payload[k];
          }
        }
        window.KAIDO.analytics.trackEvent(eventType, "reviews_social_proof", md);
      }
    } catch (_) {}
  }

  function isEligible() {
    var pt = pageType();
    if (pt !== "index" && pt !== "product") return { ok: false, reason: "page_type" };

    /* Belt-and-suspenders: if the existing drawer is already in the DOM, step aside. */
    if (document.querySelector(".kaido-review-drawer:not(.kaido-reviews-social-drawer)")) {
      return { ok: false, reason: "existing_drawer_present" };
    }

    var customerId = getCustomerId();
    var cfg = window.KAIDO_SOCIAL_PROOF_CONFIG || {};
    if (customerId) {
      if (cfg.hasReviewTokens === true) {
        return { ok: false, reason: "has_tokens" };
      }
      if (cfg.hasRecentReview === true) {
        track("suppressed_by_recent_review", {});
        return { ok: false, reason: "recent_review" };
      }
    }

    /* Cooldown-free: square always reappears after trigger on every page load. */
    return { ok: true };
  }

  function scrollable() {
    return Math.max(
      1,
      document.documentElement.scrollHeight - window.innerHeight
    );
  }

  /* v1.2 defensive picker  handles variable review field names.
     v1.4: returns an ARRAY of suitable reviews for the carousel.
     v1.5: filter tightened to 5-star ONLY (Kian requested "make sure all reviews are
     5-star"). 4-star reviews are excluded. */
  function pickFeaturedReviews(reviews, maxCount) {
    var out = [];
    if (!Array.isArray(reviews)) return out;
    var cap = typeof maxCount === "number" && maxCount > 0 ? maxCount : 5;
    for (var i = 0; i < reviews.length && out.length < cap; i++) {
      var r = reviews[i];
      if (!r || typeof r !== "object") continue;
      var rating = Number(r.rating || 0);
      var body = (typeof r.body === "string" ? r.body :
                  typeof r.text === "string" ? r.text :
                  typeof r.content === "string" ? r.content : "");
      body = body.trim();
      if (rating < 5 || body.length < 20) continue;
      var author = (typeof r.author_name === "string" && r.author_name) ||
                   (typeof r.nickname === "string" && r.nickname) ||
                   (typeof r.author === "string" && r.author) ||
                   "Verified buyer";
      out.push({
        body: body.length > 180 ? body.slice(0, 177) + "\u2026" : body,
        author: String(author).slice(0, 48),
        rating: Math.max(1, Math.min(5, Math.round(rating)))
      });
    }
    return out;
  }

  function fetchStats() {
    return fetch(STATS_ENDPOINT, { method: "GET", keepalive: true })
      .then(function (response) {
        if (!response || !response.ok) {
          track("stats_fetch_failed", {
            error_code: response && response.status >= 500 ? "http_5xx" : "http_4xx",
            error_message: "HTTP " + (response ? response.status : "no_response")
          });
          return null;
        }
        return response.json().then(function (data) {
          var stats = data && data.stats;
          if (!stats || !stats.review_count || Number(stats.review_count) === 0) {
            track("stats_fetch_failed", { error_code: "empty_stats", error_message: "no stats" });
            return null;
          }
          var featuredList = [];
          try {
            featuredList = pickFeaturedReviews(data && data.reviews, 5);
          } catch (_) { featuredList = []; }
          var result = {
            avg: Number(stats.avg_rating || 0),
            count: Number(stats.review_count || 0),
            featured: featuredList
          };
          track("stats_fetch_ok", {
            stats_review_count: result.count,
            stats_avg_rating: result.avg,
            featured_count: featuredList.length
          });
          return result;
        });
      })
      ["catch"](function (err) {
        track("stats_fetch_failed", {
          error_code: "network",
          error_message: (err && err.name) || "unknown"
        });
        return null;
      });
  }

  /* DOM builder using createElement + setAttribute + textContent only. */
  function svg(viewBox, pathD, klass, ariaHidden) {
    var s = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    s.setAttribute("viewBox", viewBox);
    s.setAttribute("fill", "currentColor");
    if (klass) s.setAttribute("class", klass);
    if (ariaHidden) {
      s.setAttribute("aria-hidden", "true");
      s.setAttribute("focusable", "false");
    }
    var p = document.createElementNS("http://www.w3.org/2000/svg", "path");
    p.setAttribute("d", pathD);
    s.appendChild(p);
    return s;
  }

  function el(tag, props) {
    var e = document.createElement(tag);
    if (props) {
      for (var k in props) {
        if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
        if (k === "className") {
          e.className = props[k];
        } else if (k === "text") {
          e.textContent = props[k];
        } else {
          e.setAttribute(k, props[k]);
        }
      }
    }
    return e;
  }

  /* v1.8: horizontal stats block  big rating number on the left, stars +
     count stacked on the right. Keeps v1.6's enhanced styling (gradient,
     SVG stars, large rating number) but roughly halves the vertical height. */
  function buildStatsBlock(stats) {
    var block = el("div", { className: "kaido-reviews-social-drawer__stats" });
    var ratingNum = el("div", { className: "kaido-reviews-social-drawer__stats-rating" });
    ratingNum.textContent = stats.avg.toFixed(1);
    block.appendChild(ratingNum);
    var info = el("div", { className: "kaido-reviews-social-drawer__stats-info" });
    var starsRow = el("div", { className: "kaido-reviews-social-drawer__stats-stars" });
    var filled = Math.max(0, Math.min(5, Math.round(stats.avg)));
    for (var i = 0; i < 5; i++) {
      var cls = "kaido-reviews-social-drawer__stats-star";
      if (i >= filled) cls += " kaido-reviews-social-drawer__stats-star--empty";
      starsRow.appendChild(svg("0 0 24 24", SVG_STAR_PATH, cls, true));
    }
    info.appendChild(starsRow);
    var countEl = el("div", { className: "kaido-reviews-social-drawer__stats-count" });
    countEl.textContent = stats.count + " verified reviews";
    info.appendChild(countEl);
    block.appendChild(info);
    return block;
  }

  /* v1.6: toggle button  click to reveal the featured carousel. */
  function buildToggleButton(onClickFn) {
    var btn = el("button", {
      className: "kaido-reviews-social-drawer__toggle",
      type: "button",
      "aria-expanded": "false",
      "aria-label": "Show a recent review"
    });
    var labelSpan = el("span", { className: "kaido-reviews-social-drawer__toggle-label" });
    labelSpan.textContent = "Show a recent review";
    btn.appendChild(labelSpan);
    var caret = svg("0 0 24 24", SVG_CARET_DOWN_PATH, "kaido-reviews-social-drawer__toggle-caret", true);
    btn.appendChild(caret);
    btn.addEventListener("click", onClickFn);
    return btn;
  }

  function buildTabBonus(avg, count) {
    /* Retained for collapsed-tab text pattern compatibility  the square tab
       actually hides this via CSS so it's effectively unused in v1.1+ but the
       DOM builder still appends it for structural symmetry with the existing drawer. */
    var wrap = el("span", { className: "kaido-review-drawer-tab__bonus" });
    var star = document.createTextNode("\u2605 ");
    wrap.appendChild(star);
    wrap.appendChild(
      document.createTextNode(avg.toFixed(1) + " \u00b7 " + count + " verified")
    );
    return wrap;
  }

  /* v1.2 featured review card  bordered quote with author + SVG star rating. */
  function buildFeaturedCard(featured) {
    var card = el("div", { className: "kaido-reviews-social-drawer__featured" });
    var body = el("p", { className: "kaido-reviews-social-drawer__featured-body" });
    body.textContent = "\u201c" + featured.body + "\u201d";
    card.appendChild(body);
    var attr = el("div", { className: "kaido-reviews-social-drawer__featured-attr" });
    var author = el("span", { className: "kaido-reviews-social-drawer__featured-author" });
    author.textContent = "\u2014 " + featured.author;
    attr.appendChild(author);
    var stars = el("span", { className: "kaido-reviews-social-drawer__featured-stars" });
    for (var i = 0; i < featured.rating; i++) {
      stars.appendChild(svg("0 0 24 24", SVG_STAR_PATH, "kaido-reviews-social-drawer__featured-star", true));
    }
    attr.appendChild(stars);
    card.appendChild(attr);
    return card;
  }

  /* v1.4 + v1.5: carousel container  cross-fades through multiple reviews,
     auto-advances every CAROUSEL_STEP_MS, user can swipe left/right to navigate
     manually, clicking a dot jumps to that slide. Any manual navigation resets
     the auto-advance timer. */
  function buildFeaturedCarousel(featuredList) {
    if (!featuredList || featuredList.length === 0) return null;
    if (featuredList.length === 1) {
      return buildFeaturedCard(featuredList[0]);
    }
    var wrap = el("div", { className: "kaido-reviews-social-drawer__featured-carousel" });
    for (var i = 0; i < featuredList.length; i++) {
      var card = buildFeaturedCard(featuredList[i]);
      card.setAttribute("data-carousel-idx", String(i));
      if (i === 0) card.classList.add("is-active");
      wrap.appendChild(card);
    }
    /* v1.6: Pointer events unified for touch (mobile) + mouse (desktop) + pen.
       Replaces v1.5 touch-only handlers  now desktop drag works too.
       Threshold: |dx| >= 40px AND |dx| > |dy| so vertical scrolls/drags
       aren't misread as horizontal swipes. */
    var pointerStartX = null;
    var pointerStartY = null;
    var pointerActiveId = null;
    wrap.addEventListener("pointerdown", function (e) {
      /* Only respond to primary mouse button or touch/pen. Ignore right-click. */
      if (e.pointerType === "mouse" && e.button !== 0) return;
      pointerStartX = e.clientX;
      pointerStartY = e.clientY;
      pointerActiveId = e.pointerId;
      /* Capture so pointer events keep flowing even if the pointer leaves the wrap */
      try { if (wrap.setPointerCapture) wrap.setPointerCapture(e.pointerId); } catch (_) {}
    });
    function _endPointer(e) {
      if (pointerStartX === null || pointerStartY === null) return;
      if (pointerActiveId !== null && e.pointerId !== pointerActiveId) return;
      var dx = e.clientX - pointerStartX;
      var dy = e.clientY - pointerStartY;
      pointerStartX = null;
      pointerStartY = null;
      pointerActiveId = null;
      try { if (wrap.releasePointerCapture && e.pointerId != null) wrap.releasePointerCapture(e.pointerId); } catch (_) {}
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      if (dx < 0) goToSlide(_carouselIdx + 1);
      else goToSlide(_carouselIdx - 1);
    }
    wrap.addEventListener("pointerup", _endPointer);
    wrap.addEventListener("pointercancel", function () {
      pointerStartX = null; pointerStartY = null; pointerActiveId = null;
    });

    /* Progress dots below the cards  clickable as buttons */
    var dots = el("div", { className: "kaido-reviews-social-drawer__featured-dots" });
    for (var j = 0; j < featuredList.length; j++) {
      var dot = el("button", {
        className: "kaido-reviews-social-drawer__featured-dot",
        type: "button",
        "aria-label": "Go to review " + (j + 1) + " of " + featuredList.length
      });
      dot.setAttribute("data-dot-idx", String(j));
      if (j === 0) dot.classList.add("is-active");
      (function (idx) {
        dot.addEventListener("click", function () { goToSlide(idx); });
      })(j);
      dots.appendChild(dot);
    }
    var container = el("div", {});
    container.appendChild(wrap);
    container.appendChild(dots);
    return container;
  }

  function buildDrawer(stats) {
    var drawer = el("div", {
      className: "kaido-review-drawer kaido-reviews-social-drawer",
      role: "complementary",
      "aria-labelledby": "kaido-social-title"
    });

    /* Close button */
    var closeBtn = el("button", {
      className: "kaido-review-drawer__close",
      "aria-label": "Close",
      type: "button"
    });
    closeBtn.textContent = "\u00d7";
    drawer.appendChild(closeBtn);

    /* aria-live two-step: append empty inner first, populate on rAF */
    var inner = el("div", {
      className: "kaido-reviews-social-drawer__inner",
      "aria-live": "polite"
    });
    drawer.appendChild(inner);

    /* Collapsed tab */
    var tab = el("button", {
      className: "kaido-review-drawer-tab kaido-reviews-social-drawer-tab",
      "aria-label": "Open KAIDO reviews",
      type: "button"
    });
    var tabIcon = el("div", { className: "kaido-review-drawer-tab__icon" });
    tabIcon.appendChild(svg("0 0 24 24", SVG_STAR_PATH, null, true));
    tab.appendChild(tabIcon);

    var tabText = el("div", { className: "kaido-review-drawer-tab__text" });
    var tabLabel = el("span", {
      className: "kaido-review-drawer-tab__label",
      text: "Reviews"
    });
    tabText.appendChild(tabLabel);
    tabText.appendChild(buildTabBonus(stats.avg, stats.count));
    tab.appendChild(tabText);

    var arrow = svg("0 0 24 24", SVG_ARROW_PATH, "kaido-review-drawer-tab__arrow", true);
    arrow.setAttribute("fill", "none");
    arrow.setAttribute("stroke", "currentColor");
    arrow.setAttribute("stroke-width", "2");
    tab.appendChild(arrow);

    document.body.appendChild(drawer);
    document.body.appendChild(tab);

    /* Two-step aria-live insert: populate on next animation frame. */
    requestAnimationFrame(function () {
      /* Header */
      var header = el("div", { className: "kaido-review-drawer__header" });
      var starIcon = el("div", { className: "kaido-review-drawer__star-icon" });
      starIcon.appendChild(svg("0 0 24 24", SVG_STAR_PATH, null, true));
      header.appendChild(starIcon);
      var headerText = el("div", {});
      var title = el("h3", {
        id: "kaido-social-title",
        className: "kaido-review-drawer__title",
        text: "See what real buyers are saying"
      });
      var subtitle = el("p", {
        className: "kaido-review-drawer__subtitle",
        text: "From verified buyers"
      });
      headerText.appendChild(title);
      headerText.appendChild(subtitle);
      header.appendChild(headerText);
      inner.appendChild(header);

      /* v1.6: Enhanced stats block (replaces single-pill stats card) */
      var statsBlock = buildStatsBlock(stats);
      inner.appendChild(statsBlock);

      /* v1.6: Toggle button + expandable carousel  only rendered if we have
         featured reviews to show. Drawer opens in COMPACT mode (carousel hidden).
         Click the toggle to expand + reveal the carousel. */
      if (stats.featured && stats.featured.length > 0) {
        try {
          var toggleBtn = buildToggleButton(onToggleExpand);
          inner.appendChild(toggleBtn);

          var expandable = el("div", { className: "kaido-reviews-social-drawer__expandable" });
          var featuredCarousel = buildFeaturedCarousel(stats.featured);
          if (featuredCarousel) expandable.appendChild(featuredCarousel);
          inner.appendChild(expandable);
        } catch (_) { /* silent  drawer still shows header + stats + CTA */ }
      }

      /* CTA */
      var cta = el("button", {
        className: "kaido-review-drawer__cta",
        type: "button",
        text: "Read reviews"
      });
      cta.addEventListener("click", onCtaClick);
      inner.appendChild(cta);
    });

    closeBtn.addEventListener("click", onClose);
    tab.addEventListener("click", onTabClick);

    return { drawer: drawer, tab: tab };
  }

  /* Module-scoped state */
  var _drawer = null;
  var _tab = null;
  var _hasFired = false;
  var _shownAt = 0;
  var _mo = null;
  /* v2: _pendingTimeout / _scrollHandler / _autoOpenTimer removed with their triggers */
  /* v1.4 carousel state + v1.5 self-scheduling timer.
     setTimeout instead of setInterval so every advance (auto OR manual) fully
     resets the countdown to the next auto-advance. */
  var _carouselTimer = null;
  var _carouselIdx = 0;
  var CAROUSEL_STEP_MS = 4500; /* 4.5s between slides */

  function _prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }

  function _carouselItems() {
    if (!_drawer) return null;
    var items = _drawer.querySelectorAll(".kaido-reviews-social-drawer__featured-carousel .kaido-reviews-social-drawer__featured");
    return (items && items.length >= 2) ? items : null;
  }

  function _carouselDots() {
    if (!_drawer) return null;
    return _drawer.querySelectorAll(".kaido-reviews-social-drawer__featured-dot");
  }

  /* Single source of truth for advancing to a slide. Wraps around.
     v1.5: any call to goToSlide restarts the auto-advance timer fresh. */
  function goToSlide(targetIdx) {
    try {
      var items = _carouselItems();
      if (!items) return;
      var total = items.length;
      var newIdx = ((targetIdx % total) + total) % total;
      if (newIdx !== _carouselIdx) {
        items[_carouselIdx].classList.remove("is-active");
        var dots = _carouselDots();
        if (dots && dots[_carouselIdx]) dots[_carouselIdx].classList.remove("is-active");
        _carouselIdx = newIdx;
        items[_carouselIdx].classList.add("is-active");
        if (dots && dots[_carouselIdx]) dots[_carouselIdx].classList.add("is-active");
      }
      /* Reset timer whether or not the idx changed  user intent to interact
         should always restart the countdown. */
      scheduleNextAutoAdvance();
    } catch (_) { /* silent */ }
  }

  function scheduleNextAutoAdvance() {
    if (_carouselTimer) {
      clearTimeout(_carouselTimer);
      _carouselTimer = null;
    }
    if (_prefersReducedMotion()) return;
    if (!_carouselItems()) return;
    _carouselTimer = setTimeout(function () {
      /* Auto-advance. goToSlide will schedule the next one. */
      goToSlide(_carouselIdx + 1);
    }, CAROUSEL_STEP_MS);
  }

  function startCarousel() {
    scheduleNextAutoAdvance();
  }

  function stopCarousel() {
    if (_carouselTimer) {
      clearTimeout(_carouselTimer);
      _carouselTimer = null;
    }
  }

  function openDrawer() {
    if (_drawer) _drawer.classList.add("is-open");
    if (_tab) {
      _tab.classList.add("is-hidden");
      _tab.setAttribute("tabindex", "-1");
    }
    /* v1.6: drawer opens in COMPACT mode  no carousel yet, just header + stats + toggle + CTA.
       Carousel auto-rotation only starts when user clicks the toggle to expand. */
  }

  function closeDrawerVisual() {
    if (_drawer) {
      _drawer.classList.remove("is-open");
      /* v1.6: also collapse expanded state so next open starts compact */
      _drawer.classList.remove("is-expanded");
      var toggleBtn = _drawer.querySelector(".kaido-reviews-social-drawer__toggle");
      if (toggleBtn) {
        toggleBtn.setAttribute("aria-expanded", "false");
        toggleBtn.setAttribute("aria-label", "Show a recent review");
        var lbl = toggleBtn.querySelector(".kaido-reviews-social-drawer__toggle-label");
        if (lbl) lbl.textContent = "Show a recent review";
      }
    }
    if (_tab) {
      _tab.classList.remove("is-hidden");
      _tab.removeAttribute("tabindex");
    }
    /* Pause carousel when drawer is collapsed OR when the expandable is closed */
    stopCarousel();
  }

  /* v1.6: toggle the expanded state to show/hide the featured review carousel. */
  function onToggleExpand() {
    if (!_drawer) return;
    var wasExpanded = _drawer.classList.contains("is-expanded");
    var toggleBtn = _drawer.querySelector(".kaido-reviews-social-drawer__toggle");
    var lbl = toggleBtn ? toggleBtn.querySelector(".kaido-reviews-social-drawer__toggle-label") : null;
    if (wasExpanded) {
      _drawer.classList.remove("is-expanded");
      if (toggleBtn) {
        toggleBtn.setAttribute("aria-expanded", "false");
        toggleBtn.setAttribute("aria-label", "Show a recent review");
      }
      if (lbl) lbl.textContent = "Show a recent review";
      stopCarousel();
      track("toggle_collapsed", {});
    } else {
      _drawer.classList.add("is-expanded");
      if (toggleBtn) {
        toggleBtn.setAttribute("aria-expanded", "true");
        toggleBtn.setAttribute("aria-label", "Hide review");
      }
      if (lbl) lbl.textContent = "Hide review";
      /* Reset carousel to first slide so every expand shows the top review */
      _carouselIdx = 0;
      var items = _carouselItems();
      if (items) {
        for (var i = 0; i < items.length; i++) {
          items[i].classList.toggle("is-active", i === 0);
        }
        var dots = _carouselDots();
        if (dots) {
          for (var j = 0; j < dots.length; j++) {
            dots[j].classList.toggle("is-active", j === 0);
          }
        }
      }
      startCarousel();
      track("toggle_expanded", {});
    }
  }

  function removeDom() {
    stopCarousel();
    if (_drawer && _drawer.parentNode) _drawer.parentNode.removeChild(_drawer);
    if (_tab && _tab.parentNode) _tab.parentNode.removeChild(_tab);
    _drawer = null;
    _tab = null;
    _carouselIdx = 0;
  }

  /* Close button: collapse drawer back to square. Do NOT remove DOM, do NOT set cooldown.
     The square stays visible until navigation or customer-login-with-tokens. */
  function onClose() {
    track("closed", {});
    closeDrawerVisual();
  }

  function onTabClick() {
    track("tab_clicked", {});
    openDrawer();
  }

  function onCtaClick() {
    var section = document.querySelector(".kaido-reviews-section");
    var target = section ? "reviews_section" : "fallback_page";
    track("cta_clicked", { target: target });
    if (section) {
      var reducedMotion =
        window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      section.scrollIntoView({
        behavior: reducedMotion ? "auto" : "smooth",
        block: "start"
      });
      try {
        var io = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting) {
                track("reviews_section_scrolled_to", {});
                io.disconnect();
                return;
              }
            }
          },
          { root: null, rootMargin: "-64px 0px 0px 0px", threshold: 0 }
        );
        io.observe(section);
      } catch (_) {}
      /* Collapse drawer back to square after scroll  square stays visible */
      setTimeout(closeDrawerVisual, 300);
    } else {
      setTimeout(function () {
        window.location.href = "/pages/reviews";
      }, 100);
    }
  }

  /* v1.3: for logged-in customers, wait for the existing review-ticket drawer to
     resolve (appear in DOM or signal reviewDrawerResolved=true via finally block
     in reviews.js initReviewDrawer) before deciding to render. Prevents the
     overlap / clipping UX bug where both drawers briefly showed at once on slow
     connections. Poll every 100ms, max wait 8 seconds. */
  function waitForReviewDrawerResolution(maxMs, cb) {
    var start = Date.now();
    function check() {
      if (document.querySelector(".kaido-review-drawer:not(.kaido-reviews-social-drawer)")) {
        cb("drawer_appeared");
        return;
      }
      if (window.KAIDO && window.KAIDO.reviewDrawerResolved === true) {
        cb("resolved_no_drawer");
        return;
      }
      if (Date.now() - start >= maxMs) {
        cb("timeout");
        return;
      }
      setTimeout(check, 100);
    }
    check();
  }

  function _doRender(source) {
    fetchStats().then(function (stats) {
      if (!stats) return; /* fail silent, no DOM */
      /* Double-check right before building: the existing drawer may have appeared
         during the stats fetch window. */
      if (document.querySelector(".kaido-review-drawer:not(.kaido-reviews-social-drawer)")) {
        track("auto_superseded", { reason: "existing_drawer_appeared_during_fetch", was_visible_ms: 0 });
        return;
      }
      var built = buildDrawer(stats);
      _drawer = built.drawer;
      _tab = built.tab;
      _shownAt = Date.now();
      track("shown", { trigger: source });
      /* v2: auto-expand removed; drawer opens only when the user clicks the tab
         (click handler wired up in buildDrawer). */
    });
  }

  function fireTrigger(source) {
    if (_hasFired) return;
    _hasFired = true;
    /* v2: no pending timers or scroll handlers to tear down. */

    var customerId = getCustomerId();
    if (customerId) {
      /* Logged-in customer: hold off until the existing drawer is definitively
         resolved. This prevents the UI overlap Kian saw on v1.2. */
      waitForReviewDrawerResolution(8000, function (reason) {
        if (reason === "drawer_appeared") {
          /* Existing drawer took over. Skip rendering entirely  one or the other, never both. */
          track("auto_superseded", { reason: "existing_drawer_resolved_first", was_visible_ms: 0 });
          return;
        }
        /* resolved_no_drawer OR timeout  safe to render */
        _doRender(source);
      });
    } else {
      /* Guest: render immediately, no wait. */
      _doRender(source);
    }
  }

  function setupMutationObserver() {
    if (_mo) return;
    try {
      _mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (
              node.nodeType === 1 &&
              node.classList &&
              node.classList.contains("kaido-review-drawer") &&
              !node.classList.contains("kaido-reviews-social-drawer")
            ) {
              var elapsed = _shownAt ? Date.now() - _shownAt : 0;
              track("auto_superseded", {
                reason: "existing_drawer_appeared",
                was_visible_ms: elapsed
              });
              /* Cooldown removed  no state rollback needed */
              removeDom();
              /* v2: auto-open / pending / scroll handlers removed with their triggers. */
              if (_mo) {
                _mo.disconnect();
                _mo = null;
              }
              return;
            }
          }
        }
      });
      _mo.observe(document.body, { childList: true, subtree: false });
    } catch (_) {}
  }

  function install() {
    var e = isEligible();
    if (!e.ok) return;

    setupMutationObserver();

    /* v2 (2026-04-18): tab mounts on pageload.
       - Guests: render immediately.
       - Logged-in customers: wait up to 8s on waitForReviewDrawerResolution so the
         review-token drawer wins if it's about to mount; otherwise render the social
         proof square. The drawer panel opens only on user click of the tab. */
    function mountNow() {
      /* Belt-and-suspenders: if the token drawer already mounted while we awaited
         resolution, skip rendering the social proof square entirely. */
      if (document.querySelector(".kaido-review-drawer:not(.kaido-reviews-social-drawer)")) return;
      fireTrigger("pageload");
    }

    if (getCustomerId()) {
      waitForReviewDrawerResolution(8000, function (reason) {
        if (reason === "drawer_appeared") {
          track("auto_superseded", { reason: "existing_drawer_resolved_first", was_visible_ms: 0 });
          return;
        }
        mountNow();
      });
    } else {
      mountNow();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", install);
  } else {
    install();
  }
})();
